import Vue from 'vue';
import Vuex from 'vuex';

import {cloneDeep} from 'lodash-es';

export default class {
  constructor() {
    Vue.use(Vuex);
    const state = {
      loading: true,
      error: false,
      data: null,
      search: '',
      model: [],
			formTypes: [],
      weightedSort: false
    };
    const getters = {
      loading: ({ loading }) => loading,
      error: ({ error }) => error,
      ready: ({ loading, error }) => !loading && !error,
      data: ({ data }) => data,
      search: ({ search }) => search,
      model: ({ model }) => model,
      formTypes: ({ formTypes }) => formTypes,
      weightedSort: ({ weightedSort }) => weightedSort,
      lookup: ({data: {categories}}) => (selection) => {
        let value;
        const findSubs = (item) => {
          if (item.categoryId === selection) {
            value = item;
            return true;
          }
          if (item.hasOwnProperty("children")) return item.children.some(findSubs);
          return false;
        }
        categories.some(findSubs);
        return value;
      }
    };
    const mutations = {
      loadData(state, data) {
        state.data = data;
      },
      setLoading(state, value) {
        state.loading = value;
      },
      setError(state, value) {
        state.error = value;
      },
      setSearch(state, value) {
        state.search = value;
      },
      setFormTypes(state, value) {
        state.formTypes = value;
      },
      setWeightedSort(state, value) {
        state.weightedSort = value
      },
      updateModel(state, {value, depth}) {
        let model = cloneDeep(state.model);
        if (depth < model.length) {
          model = model.slice(0, depth + 1);
        }
        model[depth] = value;
        state.model = model;
      }
    };
    const actions = {
      fetchData({ commit }, source) {
        return fetch(source)
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              return false;
            }
          })
          .then(data => {
            if (data) {
              commit('loadData', data);
            } else {
              commit('setError', true);
            }
          })
          .catch(() => {
            commit('setError', true);
          })
          .finally(() => {
            setTimeout(() => {
              commit('setLoading', false);
            }, 1250);
          });
      },
    };

    this.store = new Vuex.Store({
      state,
      getters,
      mutations,
      actions,
    });
  }
}
